/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { CircularProgress, Fade, withStyles } from '@material-ui/core';
import { actions as surveyActions } from '../../actions/publicSurveyActions';
import routePaths from '../../routePaths';
import moment from 'moment';

const styles = () => ({
  subHeader: {
    marginTop: 24,
    marginBottom: 16,
  },
});

class ConsultationsList extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.actions.getAll();
  }

  render() {
    return (
      this.props.surveys.fetching ? <div style={{ width: '100%', marginTop: 200, textAlign: 'center' }}><CircularProgress size={50} /></div> :
        <div>
          {this.props.surveys.data.map(survey => {
            return (
              <Fade direction="up" in={true} key={survey.id}>
                <div className="row">
                  <div className="box card">
                    <div className="col-sm-12">
                      <h2><Link to={`${routePaths.consultations}${survey.id}`} title={survey.name}>{survey.name}</Link></h2>
                      <ul className="date">
                        <li className="date_from"><i className="far fa-clock" /> <span>Data rozpoczęcia</span> {moment(survey.activeFrom).format('D MMMM YYYY HH:mm')}</li>
                        {survey.activeTo && <li className="date_to"><i className="far fa-clock" /> <span>Data zakończenia</span> {moment(survey.activeTo).format('D MMMM YYYY HH:mm')}</li>}
                      </ul>
                      <Typography variant="body1" component="p" dangerouslySetInnerHTML={{ __html: survey.description }} />
                      <div className="row btns">
                        <div className="col-sm-12">
                          <Link to={`${routePaths.consultations}${survey.id}`} className="btn" title={survey.name}>więcej</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
            );
          })}
        </div>
    );
  }
}

ConsultationsList.propTypes = {
  classes: PropTypes.object.isRequired,
  surveys: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    surveys: state.publicSurveys,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(surveyActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ConsultationsList));



// WEBPACK FOOTER //
// ./src/components/consultations/ConsultationsList.js